<template>
  <div class="index">
    <el-carousel trigger="click" :autoplay="false" height="520px" :initial-index="1">
      <el-carousel-item :key="1">
        <div class="banner">
          <img class="banner_img" src="../../assets/img/home/banner_1.png" />
          <div class="banner_text_1">
            <h4>
              <span>深度集成企业微信，</span><span>让招聘更高效</span>
            </h4>
            <h6>
              深度集成企微客服、侧边栏、加微信好友、会议日程功能
            </h6>
            <div class="button_group">
              <div class="button" @click="goRegister" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>注册企业微信</span>
              </div>
              <div class="button" @click="goUse" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>安装到企业微信</span>
              </div>
              <div class="button" @click="goUse" style="cursor:pointer;">
                <img src="../../assets/img/home/qiwei_icon.png">
                <span>企业微信登录</span>
              </div>
            </div>
            <div class="try" @click="goTry" style="cursor:pointer;">立即试用</div>
          </div>
        </div>

      </el-carousel-item>
      <el-carousel-item :key="2">
        <div class="banner">
          <img class="banner_img" src="../../assets/img/home/banner_2.png" />
          <div class="banner_text_2">
            <h4>
              易招聘
              <br />
              为招聘保驾护航
            </h4>
            <h6>
              优化招聘流程，为企业提供专业、易用和安全的SaaS软件，提升中小企业的招聘效率
            </h6>
            <div class="button_group">
              <div class="button" @click="goDing" style="cursor:pointer;">
                <span>
                  <img class="dingding_icon" src="../../assets/img/home/dingding_icon.png"  >
                </span>
                <span>钉钉应用服务商</span>
              </div>
              <div class="button"  @click="goQiwei" style="cursor:pointer;">
                <span>
                  <img class="qiwei_icon" src="../../assets/img/home/qiwei_icon_2.png">
                </span>
                <span>企业微信服务商</span>
              </div>
            </div>
          </div>
        </div>

      </el-carousel-item>
      <el-carousel-item :key="3">
        <img class="banner" src="../../assets/img/home/banner_3.png" />
      </el-carousel-item>
      <el-carousel-item :key="4">
        <img class="banner" src="../../assets/img/home/banner_4.png" />
      </el-carousel-item>
      <!-- <el-carousel-item v-for="item in 4" :key="item">
        <h3 class="small">{{ item }}</h3>
      </el-carousel-item> -->
    </el-carousel>
    <!-- <div class="swiper-container swiper-index" id="swiper">
      Additional required wrapper
      <div class="swiper-wrapper">
        Slides page1
        <div class="swiper-slide swiper_1">
          <img class="goDown" src="../../assets/img/down.png" @click="goDown" alt="">
        </div>
        <div class="swiper-slide swiper_2">
        </div>
        <div class="swiper-slide swiper_4">
        </div>
        <div class="swiper-slide swiper_5" @click="openMore">
            
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-pagination"></div>
    </div> -->

    <div class="index_item item1" id="item1">
      <div class="item_box">
        <div class="box_title">为招聘赋能，提升HR的工作效率</div>
        <div class="flex justify-content-between content_box">
          <div class="item">
            <div class="item_container">
              <div class="item_icon">
                <img src="../../assets/img/home/content_1.png" alt="" class="item_img">
              </div>
              <div class="item_title">招聘流程管理</div>
              <div class="item_content">候选人管理</div>
              <div class="item_content">职位/HC管理</div>
              <div class="item_content">应聘登记表</div>
              <div class="item_content">审批/面试/Offer自定义</div>
            </div>
          </div>
          <div class="item">
            <div class="item_container">
              <div class="item_icon">
                <img src="../../assets/img/home/content_2.png" alt="" class="item_img">
              </div>
              <div class="item_title">智能人才库</div>
              <div class="item_content">多节点人才归档</div>
              <div class="item_content">高效筛选</div>
              <div class="item_content">人才盘点</div>
              <div class="item_content">人才激活</div>
            </div>

          </div>
          <div class="item">
            <div class="item_container">
              <div class="item_icon">
                <img src="../../assets/img/home/content_3.png" alt="" class="item_img">
              </div>
              <div class="item_title">多端共享</div>
              <div class="item_content">电脑端+移动端</div>
              <div class="item_content">易招聘X钉钉</div>
              <div class="item_content">易招聘X企业微信</div>
              <div class="item_content">数据互联互通</div>
            </div>
          </div>
        </div>
        <div class="flex justify-content-between content_box">
          <div class="item">
            <div class="item_container">
              <div class="item_icon">
                <img src="../../assets/img/home/content_4.png" alt="" class="item_img">
              </div>
              <div class="item_title">招聘数据分析</div>
              <div class="item_content">招聘进度分析</div>
              <div class="item_content">角色工作量分析</div>
              <div class="item_content">影响招聘因素分析</div>
              <div class="item_content">全数据视图</div>
            </div>
          </div>
          <div class="item">
            <div class="item_container">
              <div class="item_icon">
                <img src="../../assets/img/home/content_5.png" alt="" class="item_img">
              </div>
              <div class="item_title">内部协作</div>
              <div class="item_content">数据分级管理</div>
              <div class="item_content">跨层级共享</div>
              <div class="item_content">消息盒子</div>
              <div class="item_content">通知自定义</div>
            </div>
          </div>
          <div class="item">
            <div class="item_container">
              <div class="item_icon">
                <img src="../../assets/img/home/content_6.png" alt="" class="item_img">
              </div>
              <div class="item_title">客户服务</div>
              <div class="item_content">5分钟快速客服响应</div>
              <div class="item_content">远程培训服务</div>
              <div class="item_content">24小时技术支持</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="index_item item2" id="item2">
      <div class="item_box">
        <div class="box_title">用智能工具提升招聘效率</div>
        <div class="flex justify-content-between content_box">
          <div class="item">
            <Counter :value="gaugeValue3" label="提升候选人满意度"/>
            <!-- <gauge :value="gaugeValue3"></gauge>
            <div class="gauge_value">{{ gaugeValue3 }}%</div>
            <div class="item_title">提升候选人满意度</div> -->
          </div>
          <div class="item">
            <Counter :value="gaugeValue4" label="提升HR简历筛选效率"/>
            <!-- <gauge :value="gaugeValue4"></gauge>
            <div class="gauge_value">{{ gaugeValue4 }}%</div>
            <div class="item_title">提升HR简历筛选效率</div> -->
          </div>
          <div class="item">
            <Counter :value="gaugeValue5" label="提升人才库简历数量"/>
<!-- 
            <gauge :value="gaugeValue5"></gauge>
            <div class="gauge_value">{{ gaugeValue5 }}%</div>
            <div class="item_title">提升人才库简历数量</div> -->
          </div>
          <div class="item">
            <Counter :value="gaugeValue6" label="提高招聘有效性"/>
<!-- 
            <gauge :value="gaugeValue6"></gauge>
            <div class="gauge_value">{{ gaugeValue6 }}%</div>
            <div class="item_title">提高招聘有效性</div> -->
          </div>
        </div>
        <div class="flex justify-content-between content_box">
          <div class="item"></div>
          <div class="item">
            <Counter :value="gaugeValue1" label="降低时间成本" :type="'decrease'"/>
<!-- 
            <gauge :value="gaugeValue1"></gauge>
            <div class="gauge_value">{{ gaugeValue1 }}%</div>
            <div class="item_title">降低时间成本</div> -->
          </div>
          <div class="item">
            <Counter :value="gaugeValue2" label="减少招聘支出" :type="'decrease'"/>
<!-- 
            <gauge :value="gaugeValue2"></gauge>
            <div class="gauge_value">{{ gaugeValue2 }}%</div>
            <div class="item_title">减少招聘支出</div> -->
          </div>
          <div class="item"></div>
        </div>
      </div>
      <div class="item2_text">实际使用效果可能因行业和产品使用深度产生差异</div>
    </div>
    <div class="fixed_menu flex justify-content-between align-item-center" v-if=" client == 'pc'">
      <div class="menu_item menu_qrcode experience_now">
        <img class="menu_icon experience_now_icon" src="../../assets/img/home/experience_now.png" alt="">
        <div>联系客服</div>
        <div class="qrcode_box">
          <div class="qrcode">
            <img src="../../assets/img/qr_kf_code.png" alt="">
          </div>
          客服
        </div>
      </div>
      <div class="menu_item menu_user hotline"  v-if=" client == 'pc'">
        <img class="menu_icon hotline_icon" src="../../assets/img/home/hotline.png" alt="">
        <div>客服热线</div>
        <div class="user_box">
          <div class="title">客服热线</div>
          <p>客服在线时间：工作日 09:00-18:00</p>
          <div class="phone">1300-325-3269</div>
        </div>
      </div>
      <div class="menu_item return_top" v-if=" client == 'pc'">
        <img class="menu_icon return_top" @click="toTop" src="../../assets/img/home/return_top.png" alt="">
        <div>返回顶部</div>
      </div>
    </div>
  </div>
</template>
<script>

import Swiper from 'swiper';
import gauge from '../gauge.vue';
import Counter from '../counter.vue'
export default {
  components: { gauge, Counter },
  data () {
    return {
      mySwiper: {},
      gaugeValue1: 0,
      gaugeValue2: 0,
      gaugeValue3: 0,
      gaugeValue4: 0,
      gaugeValue5: 0,
      gaugeValue6: 0,
      tempTop: 0,
      isReset: true,
      client:localStorage.getItem('client'),
    };
  },
  mounted: function () {
    this.$store.dispatch("first_nav_change", "1");
    window.addEventListener("scroll", this.handleScroll);
    this.initSwiper();
  },
  computed: {},
  methods: {
    openMore () {
      window.location.href = 'https://page.dingtalk.com/wow/dingtalk/act/dingtalk-6?wh_...nav_bgcolor=FF000000'
    },
    initSwiper () {
      this.mySwiper = new Swiper(".swiper-index", {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: true,
      });
    },
    toTop () {
      window.scrollTo(0, 0);
    },
    goDown () {
      let swiperTop = document
        .querySelector(`#swiper`).clientHeight;
      window.scrollTo(0, swiperTop + 88);
    },
    goBuy () {
      this.$router.push({ name: 'download' });
    },
    handleScroll () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; // 滚动条偏移量

      if (this.$route.name == 'index') {
        let productScroll1 = document
          .querySelector(`#item1`)
          .getBoundingClientRect().top;
        let productScroll = document
          .querySelector(`#item2`)
          .getBoundingClientRect().top;

        let isDown = scrollTop > this.tempTop;
        if (isDown) {
          // if (productScroll > 2 && this.isReset) {
          //   if (productScroll < 310) {
          //     this.gaugeValue1 = 60;
          //     this.gaugeValue2 = 80;
          //     this.gaugeValue3 = 60;
          //   } else {
          //     this.gaugeValue1 = 0;
          //     this.gaugeValue2 = 0;
          //     this.gaugeValue3 = 0;
          //     this.gaugeValue4 = 0;
          //     this.gaugeValue5 = 0;
          //     this.gaugeValue6 = 0;
          //   }
          // } else {
            this.gaugeValue1 = 60;
            this.gaugeValue2 = 80;
            this.gaugeValue3 = 60;
            this.gaugeValue4 = 80;
            this.gaugeValue5 = 75;
            this.gaugeValue6 = 80;
          // }
        } else {
          if (productScroll1 > -600) {
            this.gaugeValue1 = 0;
            this.gaugeValue2 = 0;
            this.gaugeValue3 = 0;
            this.gaugeValue4 = 0;
            this.gaugeValue5 = 0;
            this.gaugeValue6 = 0;
            this.isReset = true;
          } else {
            this.isReset = false;
          }
        }

        this.tempTop = scrollTop;
      }
    },
    goDing(){
      let url = 'https://appcenter.dingtalk.com/detail.html?goodsCode=DD_GOODS-101001048911&sig=dabf78575b0f7b9bae7fca43be1efed0'
      window.open(url,'_blank')
    },
    goQiwei(){
      let url = 'https://open.work.weixin.qq.com/appStore/app?appId=MTk3MDMyNTAzMTQ0MDI1NF8xMDI5NzczXzE%3D&source=search&delivery_from=search'
      window.open(url,'_blank')
    },
    goTry(){
      let url = 'https://open.work.weixin.qq.com/appStore/app?appId=MTk3MDMyNTAzMTQ0MDI1NF8xMDI5NzczXzE%3D&source=search&delivery_from=search'
      window.open(url,'_blank')
    },
    goRegister(){
      let url = 'https://work.weixin.qq.com/wework_admin/register_wx'
      window.open(url,'_blank')
    },
    goUse(){
      let url = 'https://open.work.weixin.qq.com/3rdservice/wework/register?permanent_reg_code=ww8db26cd2bd27f524882e5e8da472e492e1efa7e6cd758c07&notreplace=true#/v1/h5https://open.work.weixin.qq.com/3rdservice/wework/register?permanent_reg_code=ww8db26cd2bd27f524882e5e8da472e492e1efa7e6cd758c07&notreplace=true#/v1/h5'
      window.open(url,'_blank')
    },
    goLogin(){
      let url = 'https://redcs.tencent.com/'
      window.open(url,'_blank')
    },
  }
};
</script>

<style lang="scss">
.index {
  .el-carousel__container {
    height: 520px;
  }

  .el-carousel__item {
    height: 520px;
  }

  .el-carousel__item .banner {
    height: 100%;
  }

  .banner {
    height: 100%;
    position: relative;

    .banner_img {
      height: 100%;
    }

    .banner_text_1 {
      position: absolute;
      top: 150px;
      left: 360px;

      h4 {
        font-size: 44px;
        font-weight: 600;

        span:nth-child(2) {
          color: #007bff;
        }
      }

      h6 {
        font-size: 18px;
        font-weight: 400;
        color: #51565d;
        margin-top: 20px;
      }

      .button_group {
        display: flex;
        gap: 16px;

        .button {
          height: 40px;
          line-height: 38px;
          font-size: 14px;
          font-weight: 400;
          color: #007bff;
          padding: 0 18px;
          border: 1px solid #007bff;
          border-radius: 4px;
          margin-top: 40px;
          margin-bottom: 32px;

          >img {
            width: 18px;
            height: 17px;
            vertical-align: middle;
          }

          >span {
            vertical-align: middle;
          }
        }
      }
    }

    .banner_text_2 {
      position: absolute;
      top: 150px;
      left: 360px;

      h4 {
        font-size: 70px;
        font-weight: 600;
        color: #fff;
      }

      h6 {
        font-size: 16px;
        font-weight: 400;
        color: #fff;
        margin-top: 24px;
      }

      .button_group {
        display: flex;
        gap: 16px;

        .button {
          height: 30px;
          line-height: 28px;
          font-size: 12px;
          font-weight: 400;
          color: #fff;
          // padding: 0 18px;
          border: 1px solid #fff;
          border-radius: 4px;
          margin-top: 40px;
          margin-bottom: 32px;
          display: flex;

          >span:nth-child(1) {
            background-color: #fff;
            width: 28px;
            height: 28px;
            text-align: center;
            vertical-align: middle;
          }

          >span:nth-child(2) {
            padding: 0 8px;
            flex: 1;
          }

          .dingding_icon {
            width: 14px;
            height: 18px;
            vertical-align: middle;
          }

          .qiwei_icon {
            width: 19px;
            height: 16px;
            vertical-align: middle;
          }

          >span {
            vertical-align: middle;
          }
        }
      }
    }



    .try {
      width: 300px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #007bff;
      border: 1px solid #007bff;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/pages/index.vue